import type { IntlShape } from 'react-intl';
import type { KitSlotId } from 'fym-shared/src/music24/assetKinds';
import { studioThemeMessages } from '../../studio/studioThemeMessages';
import { kitMessages } from './kitMessages';

/** The name of a slot (design b1 `.ks-n b`): the asset type name, "Profile banners", "Cover". */
export function kitSlotName(intl: IntlShape, id: KitSlotId): string {
  if (id === 'cover') {
    return intl.formatMessage(kitMessages.slotCover);
  }
  if (id === 'banners') {
    return intl.formatMessage(kitMessages.slotBanners);
  }
  if (id === 'thumbnail') {
    return intl.formatMessage(kitMessages.slotThumbnail);
  }
  return intl.formatMessage(studioThemeMessages[id].name);
}
